import { Route } from 'react-router-dom';

import { PropertyDetailPage } from './pages/property-detail-page.js';
import { PropertyFormPage } from './pages/property-form-page.js';
import { PropertyListPage } from './pages/property-list-page.js';

/**
 * The module's routes, owned by the module.
 *
 * Returned as a fragment of `<Route>` elements so the app's router composes
 * modules rather than enumerating every screen in one file — which is how
 * `routes.tsx` reached 258 lines for thirteen screens.
 */
export function propertyRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/properties" element={<PropertyListPage />} />
      {/* Before the parameterised detail route: react-router ranks a static
          segment above a dynamic one, but keeping them in this order means a
          reader does not have to know that to see which wins. */}
      <Route path="/properties/new" element={<PropertyFormPage />} />
      <Route path="/properties/:propertyId/edit" element={<PropertyFormPage />} />
      <Route path="/properties/:propertyId" element={<PropertyDetailPage />} />
    </>
  );
}
